import { Localized } from "@fluent/react";
import { LoadingButton } from "@mui/lab";
import { Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { unwrapResult } from "@reduxjs/toolkit";
import { useState } from "react";
import { AppId } from "../../../app/appTypes";
import { useAppDispatch } from "../../../app/hooks"
import { DocumentDescriptionField, updateDescriptionField } from "../documentsApi";
import { SaveButton } from "../../../app/components/SaveButton";
import { CloseButton } from "../../../app/components/CloseButton";
import { useEditor } from "@tiptap/react";
import { RichTextContainer, tiptapExtensions } from "../../../app/RichTextEditor";

const Label = ({ fieldName }: { fieldName: "description" | "area" | "purpose" | "title" | "language" }) => {
    switch (fieldName) {
        case "description": return <Localized id=''>Opis</Localized>
        case "area": return <Localized id=''>Obszar</Localized>
        case "purpose": return <Localized id=''>Cel</Localized>
        case "title": return <Localized id=''>Tytuł</Localized>
        case "language": return <Localized id=''>Język</Localized>
    }
}

export interface EditRichDescriptionFieldProps {
    documentId: AppId
    fieldName: DocumentDescriptionField
    value: string
    onSuccess: (fieldName: DocumentDescriptionField, newValue: string) => void
    onCancel: () => void
}

export const EditRichDescriptionField = (props: EditRichDescriptionFieldProps) => {
    const dispatch = useAppDispatch()
    const [saving, setSaving] = useState(false)
    // const [value, setValue] = useState(props.value)

    const editor = useEditor({
        extensions: tiptapExtensions,
        content: props.value,   // initial value
    })

    const handleOkClick = () => {
        const value = editor?.getHTML() ?? ''
        setSaving(true)
        dispatch(updateDescriptionField({
            documentId: props.documentId,
            fieldName: props.fieldName,
            value
        }))
            .then(unwrapResult)
            .then(() => { props.onSuccess(props.fieldName, value) })
            .catch(err => {
                console.error(err)
            })
            .finally(() => {
                setSaving(false)
            })
    }

    return <Dialog open={true} fullWidth maxWidth='md'>
        <DialogTitle
            sx={{
                bgcolor: (theme) => theme.palette.grey[200],
                borderBottom: "1px solid",
                borderColor: "divider",
                py: 0.75,
            }}>
            <Localized id='edit'>Edycja</Localized>
        </DialogTitle>
        <DialogContent>
            <RichTextContainer label={<Label fieldName={props.fieldName} />} editor={editor} />
        </DialogContent>
        <DialogActions>
            <SaveButton loading={saving} onClick={handleOkClick} />
            <CloseButton loading={saving} onClick={props.onCancel} />
        </DialogActions>
    </Dialog>
}
